import { Action, createReducer, on } from '@ngrx/store';
import { widgetsFormCommitted, widgetsFormReset, widgetsFormSeeded } from '../actions/widgets.actions';
import { initialWidgetsState, WidgetsFormState, WidgetsState } from '../widgets.state';

/**
 * Replaces the committed form values and bumps the revision. Shared by the
 * commit and the seed action: the two carry different intent (and read
 * differently in the devtools) but have the same effect on the slice.
 *
 * @param state the widgets slice
 * @param props the action payload
 * @param props.form the new committed form values
 * @returns the slice with the new values and an incremented revision
 */
const setFormReducer = (state: Readonly<WidgetsState>, props: { form: WidgetsFormState }): Readonly<WidgetsState> => ({
    ...state,
    form: props.form,
    revision: state.revision + 1,
});

const resetFormReducer = (state: Readonly<WidgetsState>): Readonly<WidgetsState> => ({
    ...state,
    form: initialWidgetsState.form,
    revision: state.revision + 1,
});

const createWidgetsReducer = createReducer(
    initialWidgetsState,
    on(widgetsFormCommitted, setFormReducer),
    on(widgetsFormSeeded, setFormReducer),
    on(widgetsFormReset, resetFormReducer),
);

export function widgetsReducer(state: Readonly<WidgetsState>, action: Action): Readonly<WidgetsState> {
    return createWidgetsReducer(state, action);
}
